import { render, staticRenderFns } from "./FileUploadControls.vue?vue&type=template&id=6a974567&"
import script from "./FileUploadControls.vue?vue&type=script&lang=js&"
export * from "./FileUploadControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports